import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useToast } from '@chakra-ui/react';

// item 1332 (Chad: "what about 3 dots on the customer") — "Hide from project sidebar" for a whole
// CUSTOMER: ContactInfo.IsAdministrative, cascaded onto every project under it by the project
// index projection. Admin-only endpoint. Invalidates the projects index (the sidebar tree).
const useContactAdministrative = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  return useMutation(
    async ({ id, value }: { id: string; value: boolean }) => {
      const apiUrl = process.env.REACT_APP_BASIX_API || '';
      await axios.post(`${apiUrl}contacts/${id}/administrative?value=${value}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('projects');
        queryClient.invalidateQueries('contacts');
      },
      onError: () => {
        toast({
          status: 'error', title: 'Customer not updated', description: 'Admin only.', duration: 6000, isClosable: true,
        });
      },
    },
  );
};

export default useContactAdministrative;
